export const TOUR_END = 'TOUR_END';
export const tourEnd = (payload) => ({ type: TOUR_END, payload });
